export const TransactionRoute = {
    TransactionHistory: (count: number, dateStart: string): string =>
        `/dashboard/operations/${count}?start=${dateStart}`,
};
